if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core-module","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(235|677|713)|2(0(39|41|93)|487|493|941|977)|3(281|673|985)|4(027|052|297)|5(244|339|891)|65[26]1|7(015|09|45|493|586|60)|9(078|081|301)|8109|899)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}